module.exports = __webpack_public_path__ + "img/lens-160-plus-04.da2b24f2.png";